import { useContext, useMemo } from 'react';

import { CommonUtilsContext } from 'contexts/commonUtils';

import { ScPreloader } from './styled';

import defaultPreloader from 'assets/preloader/default.svg';

export const Preloader = () => {
  const { brandAssetsData } = useContext(CommonUtilsContext);

  const currentPreloader = useMemo(
    () =>
      brandAssetsData?.preloader
        ? brandAssetsData.preloader.url
        : defaultPreloader,
    [brandAssetsData]
  );

  return (
    <ScPreloader>
      <div className="logo">
        <object
          data={currentPreloader}
          height={57}
          width={200}
          aria-label="LuckyElf Casino"
        ></object>
      </div>
    </ScPreloader>
  );
};
